import { useEffect, useState } from 'react';
import GoodsIn from '../../api/controllers/GoodsIn/GoodsIn';
import './SubcontractsInIndex.scss';
// import PropTypes from 'prop-types';
import Error from '../../common/Error/Error';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import Header from '../../common/Header/Header';
import MovementFilter from '../../common/MovementFilter/MovementFilter';
import MovementLine from '../../common/MovementLine/MovementLine';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// General SubcontractsInIndex Component
const SubcontractsInIndex = () => {
  const [subcontractsIn, setSubcontractsIn] = useState();
  const [pagesToDisplay, setPagesToDisplay] = useState();
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState();
  const [error, setError] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const getSubcontractsIn = ({ pageFilter, filter, startDate, endDate }) => {
    setLoading(true);

    const formattedStartDate = startDate.toISOString().split('T')[0];
    const formattedEndDate = endDate.toISOString().split('T')[0];

    GoodsIn.all({
      hubId: hubId,
      category: 'subcontracted',
      offset: (pageFilter - 1) * 5,
      limit: 5,
      filter: filter,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      sort: 'default',
      order: 'desc',
    })
      .then(response => {
        setSubcontractsIn(response.items);

        const totalPages = Math.ceil(response.total / 5);
        setTotalPages(totalPages);
        const totalPagesArray = Array.from({ length: totalPages }, (v, i) => i + 1);
        const pageIndex = pageFilter - 1;

        setPagesToDisplay(
          totalPagesArray.slice(pageIndex - (pageIndex % 10), pageIndex + 10 - (pageIndex % 10)),
        );

        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getSubcontractsIn({
      pageFilter: 1,
      filter: '',
      startDate: new Date(),
      endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    });
  }, []);

  return (
    <div className="subcontracts_in_index_screen">
      <Header title={'Subcontracts (goods in)'} rightButton={'home'} />
      <div className="subcontracts_in_index_container">
        {error && (
          <Error
            errorMessages={error}
            type={'info'}
            errorTitle={
              Array.isArray(error)
                ? `${error.length} error${error.length > 1 ? 's occurred:' : ' occurred:'} `
                : ''
            }
          />
        )}
        {loading && <LoadingSpinner />}
        <MovementFilter
          pagesToDisplay={pagesToDisplay || []}
          updateList={getSubcontractsIn}
          totalPages={totalPages}
        />
        {subcontractsIn && subcontractsIn.length == 0 && (
          <div className="no_movements">
            <FontAwesomeIcon className="symbol" icon={faCircleInfo} data-testid="info_icon" />
            No subcontracts (goods in) matching current filters
          </div>
        )}
        {subcontractsIn && (
          <div className="subcontracts_in_list">
            {subcontractsIn.map(subcontractIn => (
              <MovementLine
                movement={subcontractIn}
                movementType={'collections'}
                key={subcontractIn.id}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// SubcontractsInIndex.propTypes = {
// };

export default SubcontractsInIndex;
